module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/8c72b45eaafa254580a22575fb541bc0.png";